import { render, staticRenderFns } from "./employeeApprovalForm.vue?vue&type=template&id=04f6e011&scoped=true"
import script from "./employeeApprovalForm.vue?vue&type=script&lang=js"
export * from "./employeeApprovalForm.vue?vue&type=script&lang=js"
import style0 from "./employeeApprovalForm.vue?vue&type=style&index=0&id=04f6e011&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f6e011",
  null
  
)

export default component.exports